import { STATUS } from '@kontentino/kontentino-constants/Posts';
import { UserPermission } from 'constants/userPermission';
import { Size } from 'types/Attachments';

/**
 * One permission may grant several statuses: the external statuses are governed by the
 * permission of the status they mirror, so no new permission is needed.
 */
export const POST_STATUS_BY_USER_PERMISSION: Record<string, number[]> = {
  [UserPermission.POST_LIST_DRAFT]: [STATUS.DRAFT],
  [UserPermission.POST_LIST_COMPLETED]: [STATUS.COMPLETED],
  [UserPermission.POST_LIST_WAITING_FOR_TASK]: [STATUS.WAITING_FOR],
  [UserPermission.POST_LIST_TASK_DONE]: [STATUS.DONE],
  [UserPermission.POST_LIST_WAITING_FOR_APPROVAL]: [
    STATUS.WAITING_FOR_INTERNAL_APPROVAL,
  ],
  [UserPermission.POST_LIST_INTERNALLY_REJECTED]: [STATUS.REJECTED],
  [UserPermission.POST_LIST_INTERNALLY_APPROVED]: [STATUS.INTERNAL_APPROVED],
  [UserPermission.POST_LIST_AT_CLIENT]: [STATUS.AT_CLIENT],
  [UserPermission.POST_LIST_REJECTED_BY_CLIENT]: [STATUS.REJECTED_BY_CLIENT],
  [UserPermission.POST_LIST_APPROVED_BY_CLIENT]: [STATUS.APPROVED],
  [UserPermission.POST_LIST_IS_SCHEDULING]: [STATUS.IS_SCHEDULING],
  [UserPermission.POST_LIST_SCHEDULED]: [
    STATUS.SCHEDULED,
    STATUS.SCHEDULED_EXTERNALLY,
  ],
  [UserPermission.POST_LIST_POSTED]: [STATUS.POSTED, STATUS.POSTED_EXTERNALLY],
  [UserPermission.POST_LIST_EXPORT_FAILED]: [STATUS.EXPORT_FAILED],
  [UserPermission.POST_LIST_EXPORTED]: [STATUS.EXPORTED],
  [UserPermission.POST_LIST_FAILED]: [STATUS.FAILED],
};

export enum FirstCommentStatus {
  Published = 'published',
  Failed = 'failed',
}

export const COMBINED_MEDIA_DOWNLOAD_SIZES: Size[] = [
  {
    tKey: 'attachmentSize.original',
    value: 'original',
  },
  {
    tKey: 'attachmentSize.thumb',
    value: 'thumb',
  },
  {
    tKey: 'attachmentSize.lightbox',
    value: 'lightbox',
  },
];

export const ORIGINAL_MEDIA_DOWNLOAD_SIZES: Size[] = [
  {
    tKey: 'attachmentSize.original',
    value: 'original',
  },
];
